import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { SkuSearchUiModule } from '@emi/sku-search/ui';
import { SharedStateSkuSearchModule } from '@emi/shared/state/sku-search';
import { HomeComponent } from './home.component';
import { InfographicsModule } from '@emi/shared/infographics';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatDialogModule,
        SharedStateSkuSearchModule,
        SkuSearchUiModule,
        InfographicsModule,
    ],
    declarations: [HomeComponent],
    exports: [HomeComponent],
})
export class SkuSearchFeatureHomeModule {}
